import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-icon-clear',
    templateUrl: './icon-clear.component.html',
    styleUrl: '../icon-shared/icon-shared.scss'
})
export class IconClearComponent {
    @Input() isActive: boolean = false;
}
